<header class="client-navbar">

    <div class="navbar-container">

        <!-- LOGO -->
        <a
            class="navbar-logo"
            href="javascript:void(0)"
            (click)="goHome()"
        >
            spe<span>K</span>wo
        </a>


        <!-- DESKTOP NAVIGATION -->
        <nav class="desktop-nav">

            <a
                href="javascript:void(0)"
                (click)="scrollToSection('how')"
            >
                HOW IT WORKS
            </a>

            <a
                href="javascript:void(0)"
                (click)="scrollToSection('problem')"
            >
                WHY SPEKWO
            </a>

            <a routerLink="/pricing">
                PRICING
            </a>

            <a routerLink="/about">
                ABOUT
            </a>


            <!-- SERVICE AREAS -->
            <div class="service-area-menu">

                <button
                    type="button"
                    class="service-area-trigger"
                >
                    SERVICE AREAS
                    <span class="dropdown-arrow">▾</span>
                </button>

                <div class="service-area-dropdown">

                    <a routerLink="/service-area-charlotte">
                        Charlotte, NC
                    </a>

                    <a routerLink="/service-area-raleigh">
                        Raleigh, NC
                    </a>

                    <a routerLink="/service-area-asheville">
                        Asheville, NC
                    </a>

                    <a routerLink="/service-area-triad">
                        The Triad, NC
                    </a>

                    <a routerLink="/service-area-upstate-sc">
                        Upstate SC
                    </a>

                </div>

            </div>


            <a
                href="javascript:void(0)"
                (click)="scrollToSection('partner')"
            >
                PARTNER
            </a>

            <a routerLink="/faq">
                FAQ
            </a>

            <a routerLink="/testimonials">
                TESTIMONIALS
            </a>

            <a routerLink="/contact">
                CONTACT
            </a>

        </nav>


        <!-- RIGHT SIDE -->
        <div class="navbar-right">

            <a
                class="navbar-phone"
                href="tel:7046261776"
            >
                ☎ 704.626.1776
            </a>

            <a
                class="navbar-quote"
                routerLink="/spekwo-products"
                [queryParams]="{ product: 'full' }"
            >
                Request a Quote
            </a>


            <!-- MOBILE MENU BUTTON -->
            <button
                type="button"
                class="mobile-menu-button"
                (click)="toggleMobileMenu()"
                [attr.aria-expanded]="mobileMenuOpen"
                aria-label="Open menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

        </div>

    </div>

</header>


<!-- MOBILE MENU -->
<div
    class="mobile-menu"
    [class.mobile-menu-open]="mobileMenuOpen"
>

    <div class="mobile-menu-header">

        <a
            class="mobile-logo"
            href="javascript:void(0)"
            (click)="goHome()"
        >
            spe<span>K</span>wo
        </a>

        <button
            type="button"
            class="mobile-close-button"
            (click)="closeMobileMenu()"
            aria-label="Close menu"
        >
            ✕
        </button>

    </div>


    <nav class="mobile-nav">

        <a
            href="javascript:void(0)"
            (click)="mobileSectionClick('how')"
        >
            How It Works
        </a>

        <a
            href="javascript:void(0)"
            (click)="mobileSectionClick('problem')"
        >
            Why speKwo
        </a>

        <a
            routerLink="/pricing"
            (click)="closeMobileMenu()"
        >
            Pricing
        </a>

        <a
            routerLink="/about"
            (click)="closeMobileMenu()"
        >
            About
        </a>


        <!-- MOBILE SERVICE AREAS -->
        <details class="mobile-service-areas">

            <summary>
                Service Areas
                <span>▾</span>
            </summary>

            <div class="mobile-service-links">

                <a
                    routerLink="/service-area-charlotte"
                    (click)="closeMobileMenu()"
                >
                    Charlotte, NC
                </a>

                <a
                    routerLink="/service-area-raleigh"
                    (click)="closeMobileMenu()"
                >
                    Raleigh, NC
                </a>

                <a
                    routerLink="/service-area-asheville"
                    (click)="closeMobileMenu()"
                >
                    Asheville, NC
                </a>

                <a
                    routerLink="/service-area-triad"
                    (click)="closeMobileMenu()"
                >
                    The Triad, NC
                </a>

                <a
                    routerLink="/service-area-upstate-sc"
                    (click)="closeMobileMenu()"
                >
                    Upstate SC
                </a>

            </div>

        </details>


        <a
            href="javascript:void(0)"
            (click)="mobileSectionClick('partner')"
        >
            Partner
        </a>

        <a
            routerLink="/faq"
            (click)="closeMobileMenu()"
        >
            FAQ
        </a>

        <a
            routerLink="/testimonials"
            (click)="closeMobileMenu()"
        >
            Testimonials
        </a>

        <a
            routerLink="/contact"
            (click)="closeMobileMenu()"
        >
            Contact
        </a>

    </nav>


    <div class="mobile-menu-bottom">

        <a
            class="mobile-phone"
            href="tel:7046261776"
        >
            ☎ 704.626.1776
        </a>

        <a
            class="mobile-quote"
            routerLink="/spekwo-products" 
            [queryParams]="{ product: 'full' }"
        >
            Request a Quote →
        </a>

    </div>

</div>